<template>
  <v-container
      fill-height
      fluid
      grid-list-xl>
    <v-layout
        justify-center
        wrap
    >

      <v-flex
          xs12
          md8
      >

        <material-card
            class="card-tabs"
            color="green">

          <v-flex
              slot="header"
          >
            Clients
          </v-flex>
          <v-flex v-if="open_ids">
            <v-select :items="open_ids" v-model="selected_id" item-text="name" item-value="id" label="Clients">

            </v-select>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn @click="move_to_graphs" :disabled="is_button_disabled">Show</v-btn>
          </v-card-actions>
        </material-card>

      </v-flex>
    </v-layout>
    <v-dialog
        v-model="progressDialog"
        hide-overlay
        persistent
        width="300"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-text>
          Loading Data
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getClients } from "../api/routes";

export default {

  name: "Clients",
  data() {
    return {
      open_ids: null,
      is_button_disabled: true,
      progressDialog: false,
      selected_id: null
    }
  },
  watch: {
    selected_id: {
      immediate: false,
      handler(value) {
        this.is_button_disabled = false;
      }
    }
  },
  methods: {
    move_to_graphs: function (){
      localStorage.setItem('open_id', this.selected_id);
      this.$router.push('/graphs');
    },
    get_clients() {
      this.progressDialog = true;
        getClients().
        then(resp => resp.data)
            .then(resp => {
          this.open_ids = resp.data;
        }).catch(error => {
          console.log(error)
        }).finally(final => {
          this.progressDialog = false;
        })
    }
  },
  mounted() {
    this.get_clients()
  }
}
</script>

<style scoped>

</style>